import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { analytics } from "./lib/analytics";
import { initSentry } from "./lib/sentry";

// Initialize monitoring
initSentry();
analytics.init();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
